module.exports = __webpack_public_path__ + "img/map-modal__img.b5cfa25c.png";